import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { RequestResponsesStatusOptions, RequestStatus } from "@/utils/models";
import { statusPendingExtraInfoColor, statusPendingExtraInfoStyles, statusStyles } from "./utils";

type StatusBadgeProps = { status: string };

export const StatusBadge: FC<StatusBadgeProps> = ({ status }) => {
	const { t } = useTranslation();

	// Transform declined status to closed before displaying
	const displayStatus = status === RequestResponsesStatusOptions.DECLINED ? RequestResponsesStatusOptions.CLOSED : status;

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, alignItems: "flex-start" }}>
			<Typography
				variant="body2"
				sx={{
					...statusStyles.base,
					...((status === RequestResponsesStatusOptions.PENDING || status === RequestStatus.Active) && statusStyles.pending),
					...(status === RequestResponsesStatusOptions.APPROVED && statusStyles.approved),
					...((status === RequestResponsesStatusOptions.DECLINED || status === RequestResponsesStatusOptions.CLOSED) && statusStyles.closed),
				}}
			>
				{t(`status.${displayStatus.toLowerCase()}`)}
			</Typography>
			{status === RequestResponsesStatusOptions.PENDING && (
				<Box sx={{ display: "flex", gap: 0.25, alignItems: "center", height: "fit-content" }}>
					<NotificationsOutlinedIcon
						fontSize={"small"}
						sx={{
							color: statusPendingExtraInfoColor,
						}}
					/>
					<Typography variant="body2" sx={statusPendingExtraInfoStyles}>
						{t("status.pending.notify")}
					</Typography>
				</Box>
			)}
		</Box>
	);
};
